import React from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log('ErrorBoundary caught an error:', error, errorInfo);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo.componentStack } },
    });
    this.logError('frontend', error.message, errorInfo.componentStack);
  }

  logError(type, message, stack) {
    console.log('Logging error:', type, message, stack);
    const errors = JSON.parse(localStorage.getItem('appErrors') || '{"frontend":[],"backend":[]}');
    errors[type].push({
      id: Date.now(),
      message,
      stack,
      timestamp: new Date().toISOString(),
    });
    localStorage.setItem('appErrors', JSON.stringify(errors));
    console.log('Updated localStorage:', localStorage.getItem('appErrors'));
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;